import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bc6c499"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4" }
const _hoisted_3 = { class: "card h-100" }
const _hoisted_4 = { class: "card-body d-flex flex-column" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-text" }
const _hoisted_7 = { class: "mt-auto" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_9 = {
  key: 1,
  class: "bg-warning missing-feature"
}
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "card h-100" }
const _hoisted_12 = { class: "card-body d-flex flex-column" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-text" }
const _hoisted_15 = { class: "mt-auto" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_17 = {
  key: 1,
  class: "bg-warning missing-feature"
}
const _hoisted_18 = { class: "col-lg-4" }
const _hoisted_19 = { class: "card h-100" }
const _hoisted_20 = { class: "card-body d-flex flex-column" }
const _hoisted_21 = { class: "card-title" }
const _hoisted_22 = { class: "card-text" }
const _hoisted_23 = { class: "mt-auto" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_25 = {
  key: 1,
  class: "bg-warning missing-feature"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('themeSettings'),
        mb: 4
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('colorScheme')), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('colorSchemeOverviewDesc')), 1),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.AbilityContext.isAuthorizedForFeature('COLOR_SCHEME'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: 'color-scheme'},
                      class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('configure')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.$t('bodyScheme')), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('bodySchemeOverviewDesc')), 1),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_THEME_SCHEME'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: 'body-scheme'},
                      class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('configure')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h5", _hoisted_21, _toDisplayString(_ctx.$t('titleScheme')), 1),
              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('titleSchemeOverviewDesc')), 1),
              _createElementVNode("div", _hoisted_23, [
                (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_THEME_SCHEME'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: 'title-scheme'},
                      class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('configure')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}